module.exports = __webpack_public_path__ + "static/media/pin.de2266b0.svg";